import paymentInstance from '../../instance'
import paymentModalLoginInstance from '../../modalLoginInstance'

const createTerminalConnectionToken = (terminalId, hasModalLogin = false) => {
	return (hasModalLogin ? paymentModalLoginInstance : paymentInstance).post(`/terminals/${terminalId}/connectionTokens`)
}

export default createTerminalConnectionToken
